module.exports = __webpack_public_path__ + "media/images/vp/icon.logo.mainslider-98e9492da87e2812188537e9cc15f24f.svg";